"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationCreateDto = void 0;
const notification_1 = require("../notification");
const misc_1 = require("../../../misc");
class NotificationCreateDto extends (0, misc_1.generateCreateDto)(notification_1.Notification, ['title', 'body', 'link', 'recipientId']) {
}
exports.NotificationCreateDto = NotificationCreateDto;
